import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row, Nav, NavItem, NavLink, TabContent, TabPane, Button, Container
} from 'reactstrap';
import classnames from 'classnames';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import ECO from './ECO/ECO';
import Stress from './Stress/Stress';
import Test from './Test/Test';
import EKG from './EKG/EKG';
import Holter from './Holter/Holter';
import Map from './Map/Map';
import Results from './Results/Results';
import Laboratorio from './Laboratorio/Laboratorio';
import renderFileInputField from '../../../../../shared/components/form/FileInput';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Tooltip from '@material-ui/core/Tooltip';

class MedicalProcedures extends Component {
  constructor(props) {
    super(props);    
    this.state = {
      activeTab: props.shouldEnabledProcedureTab,
      professional: [],
      patient: [],
      clinic: [],
      loadMedicalProcedure: false,
      validateTab: false,
      width: window.innerWidth,
      height: window.innerHeight,
      id_professionalFromEvent: null,
      filesProcedures: { filesWithServices: [], filesWithoutIdService: [] },
      ecoFiles: [],
      stressFiles: [],
      testFiles: [],
      holterFiles: [],
      mapFiles: [],
      ekgFiles: [],
      labFiles: []
    };
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  componentDidMount() {
    this.getProfessional();
    this.loadDataPatient();
    this.loadDataProfile();
    window.addEventListener('resize', this.updateWindowDimensions);
  }


  defineFirstActiveTab = () => {
    let enabledProcedures = this.props.enabledTabsProcedures;
    let shouldActiveIndex = Object.keys(enabledProcedures).find(key => enabledProcedures[key] === true);
    console.log('shouldActiveIndex', shouldActiveIndex, 'Object.keys(enabledProcedures)', Object.keys(enabledProcedures), 'this.props.enabledTabsProcedures', this.props.enabledTabsProcedures, 'enabledProcedures', enabledProcedures);
    switch (shouldActiveIndex) {
      case 'ECO':
        this.setState({ activeTab: '2' });
        break;
      case 'EKG':
        this.setState({ activeTab: '5' });
        break;
      case 'Holter':
        this.setState({ activeTab: '6' });
        break;
      case 'LAB':
        this.setState({ activeTab: '8' });
        break;
      case 'Map':
        this.setState({ activeTab: '7' });
        break;
      case 'Stress':
        this.setState({ activeTab: '3' });
        break;
      case 'Test':
        this.setState({ activeTab: '4' });
        break;

      default:
        this.setState({ activeTab: '1' });
        break;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps) {
    /* if (JSON.stringify(prevProps.FileProcedure) !== JSON.stringify(this.props.FileProcedure)) {
      console.log("There's been a change", prevProps.FileProcedure, this.props.FileProcedure)
      this.defineFilesForProcedures();
    } */
    this.getActiveTabDefault();
    if (prevProps.shouldEnabledProcedureTab !== this.props.shouldEnabledProcedureTab) {
      this.defineFirstActiveTab();
    }
  }

  //Si no es DOCTOR entonces debe traerle el trab de Procedimiento
  getActiveTabDefault = () => {
    if (!this.props.isDoctor && !this.state.validateTab) {
      console.log("NO SOY DOCTOR", this.props.enabledTabsProcedures);
      if (this.props.enabledTabsProcedures.ECO == true) {
        this.setState({ activeTab: "2", validateTab: true });
        return;
      }
      if (this.props.enabledTabsProcedures.Stress == true) {
        this.setState({ activeTab: "3", validateTab: true });
        return;
      }
      if (this.props.enabledTabsProcedures.Test == true) {
        this.setState({ activeTab: "4", validateTab: true });
        return;
      }
      if (this.props.enabledTabsProcedures.Holter == true) {
        this.setState({ activeTab: "6", validateTab: true });
        return;
      }
      if (this.props.enabledTabsProcedures.EKG == true) {
        this.setState({ activeTab: "5", validateTab: true });
        return;
      }
      if (this.props.enabledTabsProcedures.Map == true) {
        this.setState({ activeTab: "7", validateTab: true });
        return;
      }
      if (this.props.enabledTabsProcedures.LAB == true) {
        this.setState({ activeTab: "8", validateTab: true });
        return;
      }
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight }, () => console.log("ANCHO: ", this.state.width, "ALTO: ", this.state.height));
  }

  defineFilesForProcedures = () => {
    console.log('LOST', this.props.FileProcedure)
    if (!!this.props.FileProcedure) {
      if (!!this.props.FileProcedure.length) {
        console.log('LOST1', this.props.FileProcedure, "length", this.props.FileProcedure.length)
        let filesWithoutIdService = []
        let filesWithServices = []
        this.props.FileProcedure.forEach((file) => {
          console.log('LOST2', file);

          if (!!file.id_servicio) {
            const idServicio = file.id_servicio.toString();
            for (const procedure in this.props.MedicalProcedures) {

              console.log('LOST2,5', procedure, this.props.MedicalProcedures[procedure]);
              if (this.props.MedicalProcedures[procedure].id_servicio === idServicio) {
                file.procedure = procedure;
                file.wholeUrl = process.env.REACT_APP_PUBLIC_URL + file.url_adjunto + sessionStorage.getItem('token');
                filesWithServices.push(file)
              }
            }
          } else {
            file.wholeUrl = process.env.REACT_APP_PUBLIC_URL + file.url_adjunto + sessionStorage.getItem('token')
            filesWithoutIdService.push(file);
          }
        });
        console.log("LOST3", filesWithServices, filesWithoutIdService);
        this.setState({ filesProcedures: { filesWithServices, filesWithoutIdService } }, () => this.filterFileProcedures(filesWithServices))
      }
    }
  }

  filterFileProcedures = (filesAllProcedures) => {

    let ecoFiles = [];
    let stressFiles = [];
    let testFiles = [];
    let holterFiles = [];
    let mapFiles = [];
    let ekgFiles = [];
    let labFiles = [];
    if (!!filesAllProcedures) {
      if (!!filesAllProcedures.length) {
        filesAllProcedures.forEach(file => {
          switch (file.procedure) {
            case 'ECO':
              ecoFiles.push(file);
              this.setState({ ecoFiles });
              break;
            case 'EKG':
              ekgFiles.push(file);
              this.setState({ ekgFiles });
              break;
            case 'Holter':
              holterFiles.push(file);
              this.setState({ holterFiles });
              break;
            case 'LAB':
              labFiles.push(file);
              this.setState({ labFiles });
              break;
            case 'Map':
              mapFiles.push(file)
              this.setState({ mapFiles });
              break;
            case 'Stress':
              stressFiles.push(file)
              this.setState({ stressFiles });
              break;
            case 'Test':
              testFiles.push(file);
              this.setState({ testFiles });
              break;

            default:
              break;
          }
        })
      }
    }
  }

  getProfessional = async () => {

    const dataSend = { id_historia: parseInt(this.props.id_historia), id_admision: parseInt(this.props.id_admision) }

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        //console.log(data);
        this.setState({ professional: data.contenido.profesional, id_professionalFromEvent: data.contenido.id_profesional });

      })
      .catch((error) => {
        alert(error);
        console.error('Error:', error);
      });
  }

  loadDataPatient = async () => {
    const dataSend = { num_documento: this.props.num_documento };

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'paciente/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        //console.log(data);
        if (data.existe) {
          this.setState({ patient: data.contenido[0] });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  loadDataProfile = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'clinica/listar', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        this.setState({ clinic: data[0] })
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  saveProceduresPatient = async () => {
    let procedureSaved = await this.props.saveProceduresPatient();
    return procedureSaved;
  }

  deleteFileProcedure = async (id_admision, id_servicio, nameProcedure) => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'procedimientos-adjunto/delete', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify({ id_admision, id_servicio })
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error("Test");
      }
    }).then(data => {
      this.props.dropDeletedFileProcedureFromState(data, nameProcedure);
      //this.props.loadFileProcedure();
    }).catch((error) => {
      console.error('Error:', error);
    });
  }

  render() {

    const { t } = this.props;
    const { activeTab } = this.state;
    const { height, width } = this.state;

    return (
      <Fragment>
        <div className={"container-wraper-hc"} key={this.props.FileProcedure}>
          <div className="tabs tabs--bordered-top" style={{ overflow: 'hidden' }}>
            <div className="tabs__wrap">
              <Col>
                <Nav tabs >
                  {/* {this.props.isDoctor ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => {
                          this.toggle('1');
                        }}
                      >
                        Resultados
                      </NavLink>
                    </NavItem> : null} */}
                  {this.props.enabledTabsProcedures.ECO == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => {
                          this.toggle('2');
                        }}
                      >
                        {/*Gamanuclear */}
                        ECO
                      </NavLink>
                    </NavItem> : null}
                  {this.props.enabledTabsProcedures.Stress == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '3' })}
                        onClick={() => {
                          this.toggle('3');
                        }}
                      >
                        Estres
                      </NavLink>
                    </NavItem> : null}

                  {this.props.enabledTabsProcedures.Test == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '4' })}
                        onClick={() => {
                          this.toggle('4');
                        }}
                      >
                        Prueba de Esfuerzo
                      </NavLink>
                    </NavItem> : null}

                  {this.props.enabledTabsProcedures.Holter == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '6' })}
                        onClick={() => {
                          this.toggle('6');
                        }}
                      >

                        {/*Gamanuclear */}
                        Holter
                      </NavLink>
                    </NavItem> : null}

                  {this.props.enabledTabsProcedures.EKG == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '5' })}
                        onClick={() => {
                          this.toggle('5');
                        }}
                      >

                        {/*Gamanuclear */}
                        EKG
                      </NavLink>
                    </NavItem> : null}

                  {this.props.enabledTabsProcedures.Map == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '7' })}
                        onClick={() => {
                          this.toggle('7');
                        }}
                      >

                        {/*Gamanuclear */}
                        Mapa
                      </NavLink>
                    </NavItem> : null}
                  {this.props.enabledTabsProcedures.LAB == true ?
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === '8' })}
                        onClick={() => {
                          this.toggle('8');
                        }}
                      >
                        Laboratorio
                      </NavLink>
                    </NavItem> : null}
                </Nav>
              </Col>

              <Col xs={12} style={{ padding: '0.25em 0em' }}>
                <TabContent activeTab={activeTab}>
                  {/* <TabPane tabId="1">
                    <Results
                      id_admision={this.props.id_admision}
                      id_historia={this.props.id_historia}
                      medicalProcedures={this.props.MedicalProcedures}
                    />
                  </TabPane> */}
                  <TabPane tabId="2">
                    <ECO
                      id_admision={this.props.id_admision}
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.ECO.cie}
                      dataProcedure={this.props.MedicalProcedures.ECO}
                      addedMedicaments={this.props.MedicalProcedures.ECO.addedMedicaments}
                      professional={this.state.professional}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      medicament={this.props.MedicalProcedures.ECO.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      handlerTemplateProcedure={(value, typeProcedure) => this.handlerTemplateProcedure(value, typeProcedure)}
                      handlerNameTemplete={this.props.handlerNameTemplete}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      ecoFilesFromMedical={this.state.ecoFiles}
                      uploadFileProcedure={this.props.uploadFileProcedure}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <Stress
                      id_admision={this.props.id_admision}
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Stress.cie}
                      professional={this.state.professional}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      dataProcedure={this.props.MedicalProcedures.Stress}
                      medicament={this.props.MedicalProcedures.Stress.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      handlerNameTemplete={this.props.handlerNameTemplete}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      stressFilesFromMedical={this.state.stressFiles}
                      uploadFileProcedure={this.props.uploadFileProcedure}
                    />
                  </TabPane>
                  <TabPane tabId="4">
                    <Test
                      id_admision={this.props.id_admision}
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Test.cie}
                      professional={this.state.professional}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      dataProcedure={this.props.MedicalProcedures.Test}
                      medicament={this.props.MedicalProcedures.Test.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      handlerNameTemplete={this.props.handlerNameTemplete}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      resetFieldReduxForm={this.props.reset}
                      testFilesFromMedical={this.state.testFiles}
                      uploadFileProcedure={this.props.uploadFileProcedure}
                    />
                  </TabPane>
                  <TabPane tabId="5">
                    <EKG
                      id_admision={this.props.id_admision}
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.EKG.cie}
                      professional={this.state.professional}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      dataProcedure={this.props.MedicalProcedures.EKG}
                      addedMedicaments={this.props.MedicalProcedures.EKG.addedMedicaments}
                      medicament={this.props.MedicalProcedures.EKG.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      handlerNameTemplete={this.props.handlerNameTemplete}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      ekgFilesFromMedical={this.state.ekgFiles}
                      uploadFileProcedure={this.props.uploadFileProcedure}
                    />
                  </TabPane>
                  <TabPane tabId="6">
                    <Holter
                      id_admision={this.props.id_admision}
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Holter.cie}
                      professional={this.state.professional}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      dataProcedure={this.props.MedicalProcedures.Holter}
                      medicament={this.props.MedicalProcedures.Holter.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      handlerNameTemplete={this.props.handlerNameTemplete}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      holterFilesFromMedical={this.state.holterFiles}
                      uploadFileProcedure={this.props.uploadFileProcedure}
                    />
                  </TabPane>
                  <TabPane tabId="7">
                    <Map
                      id_admision={this.props.id_admision}
                      num_documento={this.props.num_documento}
                      cie={this.props.MedicalProcedures.Map.cie}
                      professional={this.state.professional}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      dataProcedure={this.props.MedicalProcedures.Map}
                      medicament={this.props.MedicalProcedures.Map.medicament}
                      handlerMedicalProcedures={this.props.handlerMedicalProcedures}
                      handlerMedications={this.props.handlerMedications}
                      selectMedicament={this.props.selectMedicament}
                      addMedicament={this.props.addMedicament}
                      removeMedicament={this.props.removeMedicament}
                      searchMedications={this.props.searchMedications}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      handlerNameTemplete={this.props.handlerNameTemplete}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      resetFieldReduxForm={this.props.reset}
                      mapFilesFromMedical={this.state.mapFiles}
                      uploadFileProcedure={this.props.uploadFileProcedure}
                    />
                  </TabPane>
                  <TabPane tabId="8">
                    <Laboratorio
                      id_admision={this.props.id_admision}
                      examResults={this.props.examResults}
                      patient={this.state.patient}
                      clinic={this.state.clinic}
                      id_professionalFromEvent={this.state.id_professionalFromEvent}
                      professional={this.state.professional}
                      saveProceduresPatient={this.saveProceduresPatient}
                      isDoctor={this.props.isDoctor}
                      isCloseClinicHistory={this.props.isCloseClinicHistory}
                      filesProcedures={this.state.filesProcedures.filesWithServices}
                      handlerFileProcedure={this.props.handlerFileProcedure}
                      deleteFileProcedure={this.deleteFileProcedure}
                      labFilesFromMedical={this.state.labFiles}
                    />
                  </TabPane>
                  {
                    activeTab != "1" ?
                      <Fragment>
                        {!!this.state.filesProcedures.filesWithoutIdService.length &&
                          this.state.filesProcedures.filesWithoutIdService.map((file) => (
                            <div style={{ margin: '0em 2em' }} key={file.id_procedimiento_adjunto}>
                              <div>
                                <b>{file.adjunto}</b>
                              </div>
                              <Tooltip title="Ver Documento">
                                <Button
                                  className="btn btn-sm"
                                  color="primary"
                                  onClick={() => {
                                    window.open(file.wholeUrl, '_blank');
                                  }}
                                >
                                  <FontAwesomeIcon icon={faFile} />
                                </Button>
                              </Tooltip>
                              <Tooltip title="Eliminar Documento">
                                <Button
                                  className="btn btn-sm"
                                  color="danger"
                                  onClick={() => {
                                    this.deleteFileProcedure(this.props.id_admision, null);
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrashAlt} />
                                </Button>
                              </Tooltip>
                            </div>
                          ))
                        }
                      </Fragment>
                      : null
                  }
                </TabContent>
              </Col>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default reduxForm({
  form: `medical-procedures-form`, // a unique identifier for this form
})(withTranslation('common')(MedicalProcedures));

